import {GET_BMI, CLEAR_BMI, CLEAR_ALL} from '../types/Type'

export const bmiReducer = (state, action) => {
    switch(action.type){
        case 'weight':
            console.log('Inside weight switch', {...state, bmi: action.payload})
            return {...state, bmi: action.payload}
            // console.log('Inside weight switch', {...state,  weight: action.stateBMI.weight})
            // console.log('Inside weight switch', {...state, bmi: {weight: action.stateBMI.bmi.weight}})
            // return {...state, bmi: {weight: action.stateBMI.bmi.weight}}
        case 'height':
            console.log('Inside height switch', {...state,  bmi: action.payload})
            return {...state,  bmi: action.payload}
            // console.log('Inside height switch', {...state, bmi: {height: action.stateBMI.height}})
            // return {...state, bmi: {height: action.stateBMI.height}}
        case GET_BMI:
            console.log('Inside BMI Results switch', {...state,  bmi: action.payload})
            return {...state,  bmi: action.payload}
        case CLEAR_BMI:
            console.log('Inside Clear BMI Results switch', {...state,  bmi: action.payload})
            return {...state,  bmi: action.payload}
        case CLEAR_ALL:
            // console.log('Inside Clear BMI All switch', {...state,   bmi: action.payload.bmi.weight, height: action.payload.bmi.height, bmiResult: action.payload.bmi.bmiResult})
            console.log('Inside Clear BMI All switch', {...state,   bmi: action.payload})
            // return {...state,  bmi: action.payload.bmi.weight, height: action.payload.bmi.height, bmiResult: action.payload.bmi.bmiResult}
            return {...state,  bmi: action.payload}
        default:
        return state;
    }
}